import {Box, Grid} from "@mui/material";
import React from "react";
import appointmentImage from "../../assets/appointment.png"
import KakaoLoginButton from "../KakaoLoginButton";

export const LoginImageAndButton: React.FC = () => {
    return <Grid container alignItems={"center"} flexDirection={"column"}>
        <Box height={"20px"}/>
        <img src={appointmentImage} style={{width: '89px', height: '89px'}}/>
        <Box height={"23px"}/>
        <div style={{padding: '0px 33px 0px 33px', width: '100%', boxSizing: 'border-box'}}>
            <KakaoLoginButton />
        </div>
        <Box height={"7px"}/>
        <span className={"description-text"} style={{fontSize: '11px'}}>약속잡기를 쓰려면 로그인이 필요해요</span>
    </Grid>;
}